module.exports = __webpack_public_path__ + "static/media/homepage_dashboard.28866be2.jpg";